// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Address_container__axCjY {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  width: 100%; /* Asigură lățimea containerului */
  box-sizing: border-box; /* Include padding și margin în dimensiunea totală */
  overflow: hidden; /* Previne orice overflow */
}

.Address_form__M7E82 {
  flex: 3 1;
  background-color: #fff;
  border: none;
  box-shadow: none;
  width: 100%; /* Asigură că formularul nu depășește lățimea */
  box-sizing: border-box;
}

.Address_cartSummary__YoTJ1 {
  flex: 2 1;
  margin-top: 20px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%; /* Previne depășirea conținutului */
  box-sizing: border-box;
}

.Address_actions__H\\+fw6 {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  flex-wrap: wrap; /* Asigură că butoanele se aliniază corect pe ecranele mici */
}

.Address_backButton__n-nPe {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px 15px;
  cursor: pointer;
  color: #000; /* Negru */
}

.Address_nextButton__rU7PH {
  background-color: #d9230f;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 8px 15px;
  cursor: pointer;
}

.Address_nextButton__rU7PH:hover {
  background-color: #c9302c;
}

@media (max-width: 768px) {
  .Address_container__axCjY {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden; /* Previne orice content overflow */
  }

  .Address_form__M7E82 {
    width: 100%; /* Ajustează lățimea pentru mobil */
  }

  .Address_cartSummary__YoTJ1 {
    width: 100%; /* Ajustează lățimea pentru mobil */
    margin-top: 10px; /* Spațiu între elemente */
  }

  .Address_actions__H\\+fw6 {
    gap: 10px; /* Spațiu între butoane */
  }

  .Address_backButton__n-nPe,
  .Address_nextButton__rU7PH {
    max-width: 50%; /* Butoanele vor ocupa întreaga lățime */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ShoppingChart/Address/Address.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,WAAW,EAAE,kCAAkC;EAC/C,sBAAsB,EAAE,oDAAoD;EAC5E,gBAAgB,EAAE,2BAA2B;AAC/C;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,WAAW,EAAE,+CAA+C;EAC5D,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,2CAA2C;EAC3C,WAAW,EAAE,mCAAmC;EAChD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe,EAAE,6DAA6D;AAChF;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW,EAAE,UAAU;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAE,mCAAmC;EACvD;;EAEA;IACE,WAAW,EAAE,mCAAmC;EAClD;;EAEA;IACE,WAAW,EAAE,mCAAmC;IAChD,gBAAgB,EAAE,0BAA0B;EAC9C;;EAEA;IACE,SAAS,EAAE,yBAAyB;EACtC;;EAEA;;IAEE,cAAc,EAAE,wCAAwC;EAC1D;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n  width: 100%; /* Asigură lățimea containerului */\n  box-sizing: border-box; /* Include padding și margin în dimensiunea totală */\n  overflow: hidden; /* Previne orice overflow */\n}\n\n.form {\n  flex: 3;\n  background-color: #fff;\n  border: none;\n  box-shadow: none;\n  width: 100%; /* Asigură că formularul nu depășește lățimea */\n  box-sizing: border-box;\n}\n\n.cartSummary {\n  flex: 2;\n  margin-top: 20px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);\n  width: 100%; /* Previne depășirea conținutului */\n  box-sizing: border-box;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 20px;\n  flex-wrap: wrap; /* Asigură că butoanele se aliniază corect pe ecranele mici */\n}\n\n.backButton {\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 8px 15px;\n  cursor: pointer;\n  color: #000; /* Negru */\n}\n\n.nextButton {\n  background-color: #d9230f;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 8px 15px;\n  cursor: pointer;\n}\n\n.nextButton:hover {\n  background-color: #c9302c;\n}\n\n@media (max-width: 768px) {\n  .container {\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    padding: 10px;\n    box-sizing: border-box;\n    overflow: hidden; /* Previne orice content overflow */\n  }\n\n  .form {\n    width: 100%; /* Ajustează lățimea pentru mobil */\n  }\n\n  .cartSummary {\n    width: 100%; /* Ajustează lățimea pentru mobil */\n    margin-top: 10px; /* Spațiu între elemente */\n  }\n\n  .actions {\n    gap: 10px; /* Spațiu între butoane */\n  }\n\n  .backButton,\n  .nextButton {\n    max-width: 50%; /* Butoanele vor ocupa întreaga lățime */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Address_container__axCjY`,
	"form": `Address_form__M7E82`,
	"cartSummary": `Address_cartSummary__YoTJ1`,
	"actions": `Address_actions__H+fw6`,
	"backButton": `Address_backButton__n-nPe`,
	"nextButton": `Address_nextButton__rU7PH`
};
export default ___CSS_LOADER_EXPORT___;
